<script setup lang="ts">
  import type { Reference } from '@/models/reference';
  import type { PropType } from 'vue';

  defineProps({
    reference: {
      type: Object as PropType<Reference>,
      required: true
    }
  });
</script>

<template>
  <div class="reference-card">
    <div class="reference-card__logo">
      <img
        :src="reference.logo?.src"
        :alt="reference.title" />
    </div>
    <div class="reference-card__label">{{ reference.title }}</div>
  </div>
</template>
